module.exports = __webpack_public_path__ + "img/spinner-a3a12cfde8c706334a80440c5c28d550.gif";